import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { currentParamState } from "../../../stores";
import { useParams } from "react-router-dom";

export function useSetCurrentParam() {
    const { group, from, floor } = useParams();
    const setCurrentParam = useSetRecoilState(currentParamState);
    useEffect(() => {
        setCurrentParam({ group, floor, from, to: undefined });
    }, [group, floor, from, setCurrentParam]);
}
